import * as React from 'react';
import { useState, useEffect, useMemo } from 'react';
import intl from 'react-intl-universal';
import { Button } from 'antd';
import { store } from '@/store';

import { PaymentDialog, BundlePaymentDialog } from 'Components/dialogs';

import './PaymentDlg.scss';
import {
  SUBSCRIBE_ACTION_MAP, SUBSCRIBE_FUNCTION_CLICK, RIGHT_TOP_FREE, RIGHT_TOP_UPGRADE, NEED_NAV_AFTER_PAY,
} from 'Components/viewer/ui/constants/event.constants.share';
import { thirdPartyService } from '@/store/services';
import { navToWithBlank } from 'Components/header/utils/utils';
import { TO_ADMIN_CONSOLE } from 'Components/viewer/ui/constants/user.more.constants';

const HeaderEntrance = () => {
  const startFreeTrial = intl.formatMessage({ id: 'account.StartFreeTrial' });
  const upgradePlan = intl.formatMessage({ id: 'account.UpgradePlan' });
  const [isShow, setIsShow] = useState(false);
  const [isShowBundle, setIsShowBundle] = useState(false);
  const [isEduBuy, setIsEduBuy] = useState(false);
  const [eduBuyParam, setEduBuyParam] = useState({});
  const {
    forShowStartTrail, forShowUpgrade, isNeedTrailState,
  } = store.accountStore;

  const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = store.userStore;
  const { isBundle } = store.accountStore;

  useEffect(() => {
    window.pdfui && window.pdfui.eventEmitter.on('need-pay-event', showPayDlg);
    return () => {
      window.pdfui && window.pdfui.eventEmitter.off('need-pay-event', showPayDlg);
    };
  }, [window.pdfui]);

  const showPayDlg = async (fromFun = false, type = '', otherParams = {}) => {
    const addInType = thirdPartyService.isFromThirdParty()
    
    if (addInType && type !== RIGHT_TOP_UPGRADE) {
      await thirdPartyService.checkPermissionAndReflect({addInType})

      return
    }

    if (otherParams && otherParams.isEduBuy) {
      setIsEduBuy(true);
      setEduBuyParam(otherParams);
      setIsShow(true);
      store.appStore.showLoading(true);
      return;
    }
    const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser, isEdu, isSuperAdmin } = store.userStore;
    const { isBundle, forShowUpgrade, isNoFirstTrail, isTrialExpired } = store.accountStore;

    if ((isEnterpriseUser && !hasEditPermissionAndEnterpriseUser) || isBundle || (forShowUpgrade && isEdu)) {
      if (isEnterpriseUser && !isSuperAdmin) {
        window.onShowWarningMessage(() => {}, { message: 'account.notActive', title: 'PhantomPDF.Online.TitleWithOnline' }, true);
        return;
      }

      if (isEnterpriseUser && isSuperAdmin && isTrialExpired) {
        window.onShowWarningMessage(isOk => {
          isOk && navToWithBlank(store.appStore.pheeAdminUrl, TO_ADMIN_CONSOLE);
        }, { message: 'account.superAdminNotActiveForSelf', title: 'PhantomPDF.Online.TitleWithOnline', ok: 'account.goAdminConsole', cancel: 'account.ok' }, false);
        return;
      }

      if (isEnterpriseUser && isSuperAdmin && isNoFirstTrail) {
        window.onShowWarningMessage((isOk) => {
          isOk && store.userStore.goFoxitStore();
        }, { message: 'account.superAdminNotActive', title: 'PhantomPDF.Online', closable: true }, true);

        setTimeout(() => {
          document.querySelector('#superAdminGetTrial').onclick = () => {
            store.userStore.goFoxitStore();
          };
        });
        return;
      }

      setIsShowBundle(true);
      store.appStore.showLoading(true);
      return;
    }

    let newType = type;
    if (fromFun) {
      newType = SUBSCRIBE_FUNCTION_CLICK;
    }
    if (newType) {
      const { eventKey, label } = SUBSCRIBE_ACTION_MAP[newType];
      store.userStore.doSendGAEventByUser({ eventKey, label });
    }

    const { hasSignIn } = store.userStore;
    if (!hasSignIn) {
      if (store.appStore.isFromServiceModeOfClient && type !== RIGHT_TOP_FREE) {
        // isFromServiceModeOfClient的时候弹窗需要判断之后弹 sign in或者sign up弹窗，但是点击开始使用需要弹sign up弹窗
        store.appStore.doShowSignInDialog();
      } else {
        store.userStore.initProcessNeedLogin('/');
      }
      return true;
    }

    setIsShow(true);
    store.appStore.showLoading(true);
  };

  const closeDlg = () => {
    setIsShow(false);
    const navAfterPayDlg = JSON.parse(window.localStorage.getItem('navAfterPayDlg'));
    navAfterPayDlg && store.appStore.emitEvent(NEED_NAV_AFTER_PAY, false);
  };

  const closeBundleDlg = (getSubInfoFlag = true) => {
    if (getSubInfoFlag) {
      store.userStore.getUserSubInfoRightNow();
    }
    setIsShowBundle(false);
  };

  const showUpgrade = useMemo(() => {
    const { isActive, isExpired, isTrial } = store.accountStore;
    const { isSuperAdmin } = store.userStore;
    if (isActive) {
      return false;
    }
    let res = forShowUpgrade || isBundle;
    if (isEnterpriseUser) {
      if (isSuperAdmin && (isExpired || isTrial)) {
        res = true;
      } else {
        res = false;
      }
    }
    return res;
  }, [isEnterpriseUser, forShowUpgrade, isBundle, hasEditPermissionAndEnterpriseUser, store.accountStore.isActive, store.userStore.isSuperAdmin]);

  // teams里组件UI返回null，但是保留了need-pay-event事件监听
  if (store.teamsAppStore.inTeamsApp) {
    return null
  }

  return (<>
    {!isEnterpriseUser && forShowStartTrail && !thirdPartyService.isFromThirdParty() && (<Button className='pay-plan-btn' onClick={() => showPayDlg(false, RIGHT_TOP_FREE)}>{startFreeTrial}</Button>)}
    {showUpgrade && (<Button className='pay-plan-btn' onClick={() => showPayDlg(false, RIGHT_TOP_UPGRADE)}>{upgradePlan}</Button>)}
    {isShow && <PaymentDialog show={isShow} close={closeDlg} isFree={isNeedTrailState} isEduBuy={isEduBuy} eduBuyParam={eduBuyParam} />}
    {isShowBundle && <BundlePaymentDialog show={isShowBundle} close={closeBundleDlg} />}
  </>);
};
export default HeaderEntrance;